import { Query, VlocApplicationStatusResult } from '@varo/graphql-schema-types';
import { useState } from 'react';
import GetVLocApplicationStatus from 'services/graphql/queries/GetVlocApplicationStatus';
import { CombinedError, useQuery } from 'urql';

interface GetVLocApplicationStatusResult {
  result?: VlocApplicationStatusResult;
  error?: CombinedError;
  fetching: boolean;
  refetchCheck: () => void;
}

const useGetVLocApplicationStatus = (
  applicationId: string,
): GetVLocApplicationStatusResult => {
  const [isPaused, setIsPaused] = useState(true);
  const [response, refetch] = useQuery<Query>({
    query: GetVLocApplicationStatus,
    variables: { statusInput: { applicationId } },
    requestPolicy: 'network-only',
    pause: isPaused,
  });

  const refetchCheck = () => {
    setIsPaused(false);
    refetch();
  };

  const { data, fetching, error } = response;

  return {
    result: data?.getVLocApplicationStatus,
    fetching,
    error,
    refetchCheck,
  };
};

export default useGetVLocApplicationStatus;
